<template>
  <b-modal
    :visible="open"
    centered
    lazy
    dialog-class="language-modal__dialog"
    content-class="language-modal__content"
    header-class="language-modal__header"
    body-class="language-modal__body"
    footer-class="language-modal__footer"
    @show="resetSelection"
    @change="$emit('update:open', $event)"
  >
    <template #modal-header="{ close }">
      <h2 class="language-modal__title">{{ $t('configuracoesidioma') }}</h2>
      <button
        type="button"
        class="language-modal__close"
        :aria-label="$t('fechar')"
        @click="close()"
      >
        <lucide-icon :icon="closeIcon" :size="20" aria-hidden="true" />
      </button>
    </template>

    <div class="language-modal__inner">
      <p class="language-modal__description">
        {{ $t('selecioneidiomapreferencia') }}
      </p>

      <div
        role="radiogroup"
        :aria-label="$t('idioma')"
        class="language-modal__options"
      >
        <label
          v-for="option in options"
          :key="option.locale"
          class="language-option"
          :class="{ 'is-checked': selected === option.locale }"
        >
          <span>{{ $t(option.labelKey) }}</span>
          <input
            type="radio"
            class="language-option__radio"
            :name="radioName"
            :value="option.locale"
            :checked="selected === option.locale"
            @change="selected = option.locale"
          />
        </label>
      </div>
    </div>

    <template #modal-footer="{ close }">
      <button
        type="button"
        class="dm-button dm-button--secondary-outline"
        @click="close()"
      >
        {{ $t('cancel') }}
      </button>
      <button
        type="button"
        class="dm-button dm-button--primary"
        @click="confirm"
      >
        {{ $t('confirmar') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import { X } from 'lucide'
import LucideIcon from '@/components/LucideIcon'

export default {
  name: 'LanguageSettingsModal',
  components: { LucideIcon },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    currentLocale: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    }
  },
  emits: ['update:open', 'confirm'],
  data() {
    return {
      selected: this.currentLocale
    }
  },
  computed: {
    radioName() {
      return `language-option-${this._uid}`
    },
    closeIcon() {
      return X
    }
  },
  methods: {
    resetSelection() {
      this.selected = this.currentLocale
    },
    confirm() {
      if (this.selected !== this.currentLocale) {
        this.$emit('confirm', this.selected)
      }
      this.$emit('update:open', false)
    }
  }
}
</script>
